export default "__VITE_ASSET__BTphvUpI__"